import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SideNavService } from '../../../../../../../services/side-nav.service';
import { MatDialog } from '@angular/material/dialog';
import { CalsoftService } from '../../../../../../../services/calsoft.service';
import { CommonService } from '../../../../../../../services/common.service';
import { CustomFlexLayoutModule } from '../../../../../../../flex-layout/custom-flex-layout.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'calsoft-side-bar-child-popup',
  imports: [CustomFlexLayoutModule, MatButtonModule, MatIconModule],
  templateUrl: './side-bar-child-popup.component.html',
  styleUrl: './side-bar-child-popup.component.scss'
})
export class SideBarChildPopupComponent implements OnInit {
  @Input() menuItems:any=[];
  @Input() menuParentId=2;
  parentMenu:Array<any> | any;
  menuId: string|any;

  @Input() depth: number = 0;

  constructor(private sidenavMenuService:SideNavService,    
    private dialog: MatDialog, 
      public calsoftService: CalsoftService, private renderer: Renderer2,private commonService:CommonService, ) { }

  ngOnInit() {
    this.parentMenu = this.menuItems;
  }

  onClick(menuId: any,parentId: any,menu: any){
    this.sidenavMenuService.toggleMenuItem(menuId,parentId,menu);
    this.sidenavMenuService.closeOtherSubMenus(this.menuItems, menuId);    
  }


  toggleMenuItem(menuId: string) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
  
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        this.renderer.removeClass(menuItem, 'expanded');
      } else {
        subMenu.classList.add('show');
        this.renderer.addClass(menuItem, 'expanded');
        this.menuId=menuId;
      }
    }
  }
  isExpanded(menuId: string): any {
    // Check if the menu item is expanded
    if(this.sidenavMenuService.expandedItems.findIndex((item:any) => item === menuId)>=0) {
      return true;
    }else{
      return false;
    }
  }

  goToCategory(menu :any) {

    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);
   this.dialog.closeAll();
  

 }

}

